import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { QUERY_NAME, SERVICES } from "@lhd/constants";
import axios from "@lhd/libs/axios";
import { getCompanyId } from "@lhd/utility";
import { notification } from "antd";
import { normalizeSavePayloadRecursively } from "@lhd/utility";

export const useSubmitSettings = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ payload }: any) =>
      axios({
        method: "post",
        url: `${SERVICES.APP_PERMISSIONS}/save`,
        data: {
          ...normalizeSavePayloadRecursively(payload),
          company_id: getCompanyId(),
        },
      }),
    {
      onSuccess() {
        queryClient.invalidateQueries([QUERY_NAME.GROUP_PERMISSIONS_SETTING]);
        notification["success"]({
          message: "保存しました",
        });
      },
    },
  );
};

export const useFetchSettingPermissions = () => {
  const companyId = getCompanyId();
  return useQuery(
    [QUERY_NAME.GROUP_PERMISSIONS_SETTING, companyId],
    () =>
      axios({
        method: "get",
        url: SERVICES.APP_PERMISSIONS,
        params: {
          company_id: companyId,
          target: "appraisal",
        },
      }).then((res) => ({
        data: res.data as any,
      })),
    {
      cacheTime: 300,
      staleTime: 300,
    },
  );
};
